import { ExcelMapperSettings } from "@/models/excel-mapper-settings";
import { Axios } from "../axios";

export class ExcelMapperService {
	public readonly url:string;

	public constructor(url:string){
		this.url = url;
	}

	public async getSettings():Promise<ExcelMapperSettings[]> {
		let result = await Axios.get(`${this.url}`);
		return ((result.data || []) as any[]).map(e=>new ExcelMapperSettings(e));
	}

	public async createSetting(settings:ExcelMapperSettings):Promise<ExcelMapperSettings>{
		let result = await Axios.post(`${this.url}`, settings.getJSON());
		return new ExcelMapperSettings(result.data);
	}

	public async updateSetting(settings:ExcelMapperSettings):Promise<ExcelMapperSettings>{
		let result = await Axios.put(`${this.url}/${settings.ID}`, settings.getJSON());
		return new ExcelMapperSettings(result.data);
	}

	public async deleteSetting(settings:ExcelMapperSettings):Promise<void>{
		await Axios.delete(`${this.url}/${settings.ID}`);
	}
}